import { render, staticRenderFns } from "./ItemNew_Details.vue?vue&type=template&id=10e1f77e&"
import script from "./ItemNew_Details.vue?vue&type=script&lang=js&"
export * from "./ItemNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports